import { useCallback, useEffect, useState } from "react";
import { Col, Container, Dropdown, Row, Tab } from "react-bootstrap";
import {
  CommonSelect,
  CommonToolTip,
  CstmPagination
} from "../../../../components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import {
  SUPPORT_STAFF_ADD,
  SUPPORT_STAFF_EDIT,
  SUPPORT_STAFF_TASK
} from "config/paths";
import { useDispatch, useSelector } from "react-redux";
import { initialFilterState, supportStaffFilter } from "store/slices/filter";
import { usePersistentState } from "hooks/usePersistentState";
import TableLayoutV2 from "components/TableLayoutV2";
import CommonButton from "components/Common/CommonButton";
import { useDeleteSupportStaffMutation, useGetSupportStaffClientsQuery, useGetSupportStaffDataQuery, useResendSupportStaffInviteMutation } from "store/services/V2/supportStaff";
import { Link, useNavigate } from "react-router-dom";
import dummyProfile from '../../../../Assets/images/dummyProfileIcon.png'
import { SearchIcon, ThreeDotsMenuIcon } from "Assets/icons/v2";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { debounce } from "lodash";
import { CLIENT_STATUS_OPTION, STAFF_TYPE_OPTIONS, SUPPORT_STAFF_STATUS_OPTION } from "config/constants";
import { useLazyAssignedSchoolsLookupQuery } from "store/services/utility";
import { dateFormat, successMessageToast } from "helpers/common";

const SupportStaff = () => {
  const dispatch = useDispatch();
  const Navigate = useNavigate()

  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [schoolOptions, setSchoolOptions] = useState([]);


  const [currentPage, setCurrentPage] = usePersistentState("supportStaff:page", 1);
  const [pageSize, setPageSize] = useState(10);
  const filter = useSelector(state => state?.filter?.supportStaffFilter);
  const { data, isLoading, isError, isFetching } = useGetSupportStaffDataQuery(
    { page: currentPage, limit: pageSize, ...filter }
  );
  const schoolClients = data?.records;
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const [deleteSupportStaff, { isLoading: deleteLoading }] = useDeleteSupportStaffMutation()
  const [getSchools, { isFetching: schoolsLoading }] = useLazyAssignedSchoolsLookupQuery()
  const { data: supportClientList, isLoading: supportClientLoading } = useGetSupportStaffClientsQuery()
  const [resendInvite, { isLoading: resendInviteLoading }] = useResendSupportStaffInviteMutation()

  const handleRensendInvite = async (item) => {
    try {
      const result = await resendInvite({ id: item?.id }).unwrap()
      successMessageToast(result?.message)
    } catch (error) {
      console.log('error resending invite to user: ', error)
    }
  }


  const column = [
    // {
    //   head: <div onClick={() => dispatch(supportStaffFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
    //   accessor: "is_favorite",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1) }}>{item?.client_detail?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
    //   ),
    // },

    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-10">
          <div className="imgWrp flex-shrink-0">
            <img
              src={item?.staffDetail?.profile_picture || dummyProfile}
              alt=""
              className="img-fluid rounded-circle object-fit-cover"
              style={{ height: 22, width: 22 }}
            />
          </div>
          <h6 className="m-0 fw-sbold">
            <Link
              className="text-dark"
            // to={generatePath(THERAPIST_DETAIL, { id: item.id })}
            >
              {item.firstname}
            </Link>
          </h6>
        </div>
      ),
    },
    {
      head: <div className="d-flex align-items-center">Last Name</div>,
      accessor: "lastname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="d-flex align-itmes-center">
          <h6 className="m-0 fw-sbold">{item.lastname}</h6>
        </div>
      ),
    },

    {
      head: "Date Created",
      accessor: "createdAt",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => (
        <span>{item?.createdAt ? dateFormat(item?.createdAt, "MMM DD, YYYY") : "--"}</span>
      ),
    },

     {
      head: "Staff Type",
      accessor: "client_type",
      isComponent: true,
      width: "100%",
      component: (item) => (
        <span>{item?.staffDetail?.client_type == 'home_education' ? "Home Education" : "School"}</span>
      ),
    },

    {
      head: "School",
      accessor: "school_support_staff",
      sorter: true,
      component: (item, ind) => {
        const schoolList = item?.school_support_staff || [];
        const tooltipContent = schoolList.length ? (
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {schoolList.map((s, i) => (
              <li
                key={i}
                style={{ position: "relative", paddingLeft: "10px", marginBottom: "2px", textAlign: "left" }}>
                <span style={{ position: "absolute", left: 0, top: 0 }}>•</span>
                {s?.schools?.name}
              </li>
            ))}
          </ul>

        ) : (
          "NA"
        );

        const firstSchool = schoolList?.[0]?.schools?.name;

        const displayText = firstSchool ? (
          schoolList.length > 1 ? (
            <>
              {firstSchool}...+<span>{schoolList.length - 1}</span>
            </>
          ) : (
            firstSchool
          )
        ) : (
          "NA"
        );


        return (
          <CommonToolTip
            text={tooltipContent}
            component={<p className="mb-0">{displayText}</p>}
          />
        );
      },
    },
    {
      head: "",
      accessor: "",
      isComponent: true,
      sorter: false,
      component: (item, ind) => (
        <div className="d-flex align-itmes-center">
          <span>{item?.total_tasks ? item?.total_tasks : 0} tasks</span>
        </div>
      ),
    },

    {
      // head: "Action",
      accessor: "",
      isComponent: true,
      component: (item, index) => (
        item?.status != "discharged" &&
        <Dropdown
          onClick={(e) => e.stopPropagation()}
        // show={index == dropdownIndex}
        // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
        >
          <Dropdown.Toggle
            variant="transparent"
            className="p-0 border-0 text-dark w-100"
            id="dropdown-basic"
          >
            <ThreeDotsMenuIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
            <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
              <h5 onClick={(e) => {
                e.stopPropagation();
                Navigate(SUPPORT_STAFF_EDIT.replace(":id", item.id));
              }} className="cursor-pointer proxima mb-2">
                Edit
              </h5>
              <h5 onClick={(e) => {
                e.stopPropagation();
                if (!resendInviteLoading) {
                  handleRensendInvite(item)
                }
              }} className="cursor-pointer proxima mb-2">
                Resend Invite to User
              </h5>
              {/* <h5 onClick={(e) => {
                e.stopPropagation();
                setCurrentEntry(item);
                setShowModal(true);

              }} className="cursor-pointer proxima mb-2">
                Delete
              </h5> */}

            </ul>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
  ];

  const getSchoolOptions = async (search) => {
    try {

      const result = await getSchools(search);
      if (result?.data?.[0]?.id) {
        const data = result?.data?.map((item) => ({ label: item?.name, value: item?.id }))
        setSchoolOptions(data);
      }
    } catch (error) { console.error("Error Getting school options"); };

  };

  useEffect(() => {
    getSchoolOptions()
  }, [])


  const handleFavouriteReport = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      await favouriteClient({ data, id }).unwrap()
    } catch (error) {
      console.error('error making the client favourite: ', error)
    }
  }

  const handleFilterChange = (key) => (value) => {
    dispatch(supportStaffFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleSearchChange = useCallback(debounce((value) => {
    handleFilterChange("search")(value);
  }, 500), [handleFilterChange, 500]);

  const handleSearch = useCallback(debounce((value) => {
    if (value) getSchoolOptions(value);
  }, 500), []);

  const resetFilter = () => {
    dispatch(supportStaffFilter(initialFilterState.supportStaffFilter));
    setCurrentPage(1)
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to first page when page size changes
  };

  const handleGetRowColor = (item) => {
    if (item?.status == "discharged") {
      return "rowYellow";
    }
    else if (item?.status == "inactive") {
      return "rowGray";
    }
  }


  const handleDelete = async () => {
    try {
      setShowModal(false);
      const result = await deleteSupportStaff({ id: currentEntry?.id }).unwrap();
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error deleting template", err);
    };
  };

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type="delete"
      />

      <section className="client position-relative py-4">
        <Container fluid>
          {isLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> : <Row>
            <Col lg="12">
              <Row className='left classroom-conslutation d-flex justify-content-between align-items-end'>
                <Col><h6 className="m-0  fw-bold main-head themeBlue">Support Staff</h6></Col>
                <Col className="d-flex justify-content-end">
                  <CommonButton className="staff-button-outlined" text="Add Support Staff" onClick={() => Navigate(SUPPORT_STAFF_ADD)} />
                </Col>
              </Row>
              <Row className="reports-v2 d-flex justify-content-end gap-2 gap-lg-0 mt-3">
                <Col md='3'>
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">School</label>
                    <CommonSelect
                      placeholder={"Choose one"}
                      option={schoolOptions}
                      onChange={(e) => handleFilterChange("school")(e)}
                      value={filter?.school}
                      onInputChange={(val) => handleSearch(val)}
                      isFilterV2
                      isClearable
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                      isLoading={schoolsLoading}
                    />
                  </div>
                </Col>
                <Col md='3'>
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Staff</label>
                    <CommonSelect
                      placeholder={"Choose one"}
                      options={
                        supportClientList
                          ?.map(item => ({
                            value: item.id,
                            label: `${item.firstname} ${item.lastname ?? ""}`,
                          }))
                      }
                      onChange={(e) => handleFilterChange("support_staff")(e)}
                      value={filter?.support_staff}
                      onInputChange={(val) => handleSearch(val)}
                      isFilterV2
                      isClearable
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                      isLoading={supportClientLoading}
                    />
                  </div>
                </Col>
                          <Col xs='4' xl="2">
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Staff Type</label>
                    <CommonSelect
                      placeholder={"Select"}
                      option={STAFF_TYPE_OPTIONS}
                      onChange={(e) => handleFilterChange("plan_client_type")(e)}
                      value={filter?.plan_client_type}
                      isClearable
                      isFilterV2
                      // isClearable
                      // isLoading={schoolListLoading || schoolListFetching}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    />
                  </div>
                </Col>
                <Col xs='4' xl="2">
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Status</label>
                    <CommonSelect
                      placeholder={"Select"}
                      option={SUPPORT_STAFF_STATUS_OPTION}
                      onChange={(e) => handleFilterChange("status")(e)}
                      value={filter?.status}
                      isFilterV2
                      // isClearable
                      // isLoading={schoolListLoading || schoolListFetching}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    />
                  </div>
                </Col>
                <Col xs="7" xl="2">
                  <div className="d-flex align-items-center gap-3 search-input-filter-v2 readonly-box">
                    <input
                      onChange={(e) => handleSearchChange(e.target.value)}
                      className="border-0 shadow-none h-auto w-100"
                      placeholder="Search..."
                      defaultValue={filter?.search}
                      style={{ outline: "none" }}
                    />
                    <SearchIcon />
                  </div>
                </Col>
              </Row>

              <div className="table-outer mt-3">
                {isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || deleteLoading || resendInviteLoading) && <LoadingOverlay />}
                    <TableLayoutV2
                      data={schoolClients}
                      column={column}
                      filter={filter}
                      url={SUPPORT_STAFF_TASK.replace("/:id", "")}
                      handleSort={handleFilterChange("sort")}
                      handleGetRowColor={handleGetRowColor}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  className={'paginationV2'}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};



export default SupportStaff;


